import type { CampaignImproveItemDefinition, CampaignImproveItemId } from '@/types/campaign-improve';

/** CAMPAIGN-IMPROVE SKU pillars per docs/operations/07-legal-services-incident.md */
export const CAMPAIGN_IMPROVE_ITEM_DEFINITIONS: readonly CampaignImproveItemDefinition[] = [
  {
    itemId: 'CI1',
    label: 'Baseline documented',
    description: 'Pre-campaign baseline narrative captured for readouts.',
    defaultOwner: 'CS + data',
    supportsAutoComplete: true,
  },
  {
    itemId: 'CI2',
    label: 'Floor intervention executed',
    description: 'Document spotlight, placement, or merchandising changes on the floor.',
    defaultOwner: 'CS',
    supportsAutoComplete: false,
  },
  {
    itemId: 'CI3',
    label: 'Case study / proof package ready',
    description: 'Approved proof linked to the case study URL on the campaign card.',
    defaultOwner: 'CS + data',
    supportsAutoComplete: true,
  },
  {
    itemId: 'CI4',
    label: 'Exec readout delivered',
    description: 'Improvement campaign readout review-due marked completed.',
    defaultOwner: 'CS',
    supportsAutoComplete: true,
  },
] as const;

export const CAMPAIGN_IMPROVE_ITEM_IDS = CAMPAIGN_IMPROVE_ITEM_DEFINITIONS.map((item) => item.itemId);

export const CAMPAIGN_IMPROVE_STATUS_LABELS: Record<
  import('@/types/campaign-improve').CampaignImproveItemStatus,
  string
> = {
  not_started: 'Not started',
  in_progress: 'In progress',
  complete: 'Complete',
  blocked: 'Blocked',
  waived: 'Waived',
};

export function getCampaignImproveItemDefinition(itemId: CampaignImproveItemId): CampaignImproveItemDefinition {
  const definition = CAMPAIGN_IMPROVE_ITEM_DEFINITIONS.find((item) => item.itemId === itemId);
  if (!definition) {
    throw new Error(`Unknown campaign improve item: ${itemId}`);
  }
  return definition;
}
